import { TextModelEmail, UserReadModel } from "../../GeneratedClients/FreeBillApi"
import textModelEmailTemplate from "../../fixtures/textModelEmailTemplate"

const substituteVariables = (text?: string, user?: UserReadModel) => {
  const mapper = {
    _Firmenname: user?.company?.companyName
  }
  //@ts-ignore
  return text?.replace(/\b(?:_Firmenname)\b/gi, matched => mapper[matched])
}

const defaultTextInvoice = (user?: UserReadModel) => {
  return substituteVariables(`${user?.textModelEmail?.sendInvoiceEmailText ? user.textModelEmail.sendInvoiceEmailText : textModelEmailTemplate.sendInvoiceEmailText}`, user)
}


const defaultTextInvoiceReminder = (user?: UserReadModel, reminderStepNumber?: number | null) => {
  const index = reminderStepNumber && reminderStepNumber > 2 ? 2 : reminderStepNumber??0
  return substituteVariables(invoiceReminderTextList(user?.textModelEmail)[index], user)
}

const defaultTextReverseInvoice = (user?: UserReadModel) => {
  return substituteVariables(`${user?.textModelEmail?.sendReverseInvoiceEmailText ? user.textModelEmail.sendReverseInvoiceEmailText : textModelEmailTemplate.sendReverseInvoiceEmailText}`, user)
}


const invoiceReminderTextList = (textModelEmail?: TextModelEmail) => [
  `${textModelEmail?.sendInvoiceReminderEmailTextStep1 ? textModelEmail.sendInvoiceReminderEmailTextStep1 : textModelEmailTemplate.sendInvoiceReminderEmailTextStep1}`,
  `${textModelEmail?.sendInvoiceReminderEmailTextStep2 ? textModelEmail.sendInvoiceReminderEmailTextStep2 : textModelEmailTemplate.sendInvoiceReminderEmailTextStep2}`,
  `${textModelEmail?.sendInvoiceReminderEmailTextStep3 ? textModelEmail.sendInvoiceReminderEmailTextStep3 : textModelEmailTemplate.sendInvoiceReminderEmailTextStep3}`
]

export { defaultTextInvoice, defaultTextInvoiceReminder, defaultTextReverseInvoice }
